import { Radio, RadioGroup } from '@workramp/ui';
import { MixPanel } from '~/common';
import { I18n } from '~/common/explicit-exports';
import { UpdateDate } from '../../types';
import { LearnerSearchMixpanelEvents } from '../../constants';

interface AdvancedSearchFilterUpdatedDateRadioGroupProps {
  filterUpdatedDate: UpdateDate;
  setFilterUpdatedDate: (updatedDate: UpdateDate) => void;
}

export const AdvancedSearchFilterUpdatedDateRadioGroup = ({
  filterUpdatedDate,
  setFilterUpdatedDate,
}: AdvancedSearchFilterUpdatedDateRadioGroupProps) => {
  const LAST_7_DAYS = I18n.t('js.learner.advanced_search.filters.last_7_days');
  const LAST_30_DAYS = I18n.t('js.learner.advanced_search.filters.last_30_days');
  const LAST_YEAR = I18n.t('js.learner.advanced_search.filters.last_year');
  const ALL_TIME = I18n.t('js.learner.advanced_search.filters.all_time');

  const contentUpdatedDateFilterOptionsInfo = {
    label: 'Updated Date',
    options: [
      { label: LAST_7_DAYS, value: UpdateDate.LAST_7_DAYS },
      { label: LAST_30_DAYS, value: UpdateDate.LAST_30_DAYS },
      { label: LAST_YEAR, value: UpdateDate.LAST_YEAR },
      { label: ALL_TIME, value: UpdateDate.ALL_TIME },
    ],
  };

  return (
    <RadioGroup
      value={filterUpdatedDate}
      onChange={(updatedDate: UpdateDate) => {
        setFilterUpdatedDate(updatedDate);
        MixPanel.track(LearnerSearchMixpanelEvents.LEARNER_ADVANCED_SEARCH_SELECTS_UPDATED_FILTER_VALUE, {
          updatedDate,
        });
      }}
    >
      {contentUpdatedDateFilterOptionsInfo.options.map((option, index) => (
        <Radio key={option.label} value={option.value} autoFocus={index === 0}>
          {option.label}
        </Radio>
      ))}
    </RadioGroup>
  );
};
